module.exports = __webpack_public_path__ + "media/dogs/dog-standing-a12a66a2.svg";